'use strict'

// A sample component

const Timeline = {
    init: function () {
        Timeline.container = document.querySelector('.c-residence-calendar_container');
        if (Timeline.container) {
            this.timelineCustom();
        }
    },

    timelineCustom: function () {
        var bloc = Timeline.container;
        var startX = 0;
        var startScroll = 0;
        var isDown = false;

        function mouseStart(e) {
            isDown = true;
            startScroll = bloc.scrollLeft;
            startX = e.clientX;
        }

        function mouseEnd(e) {
            isDown = false;
        }

        function mouseMove(e) {
            if (isDown) {
                bloc.scrollLeft = startScroll + (startX - e.clientX);
            }
        }

        function touchStart(e) {
            bloc.style.overflowX = "auto";
        }

        bloc.addEventListener("mousedown", mouseStart);
        bloc.addEventListener("mouseup", mouseEnd);
        bloc.addEventListener("mousemove", mouseMove);
        bloc.addEventListener("touchstart", touchStart);
    }
}


export default Timeline;



// WEBPACK FOOTER //
// ./src/scripts/components/Timeline.js